(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('DeleteTravelExpensesController', DeleteTravelExpensesController);

    DeleteTravelExpensesController.$inject = ['$uibModalInstance', 'expense', 'expensesList', 'TravelExpenseService', 'toastr'];

    function DeleteTravelExpensesController($uibModalInstance, expense, expensesList, TravelExpenseService, toastr) {
        var vm = this;
        vm.expense = expense;
        vm.expensesList = expensesList;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            vm.query = [];
            vm.query['id'] = vm.expense.id;
            TravelExpenseService.deleteTravelExpense(vm.query).then(function(response) {
                if(response.data.status_code !== 200) {
                    toastr.error(response.data.msg);
                } else {
                    toastr.success(response.data.msg);
                    vm.expensesList.splice(vm.expensesList.indexOf(expense), 1);
                    if(vm.expensesList.length==0){
                        vm.flag = false;
                    }
                }
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();